import { Component, Input, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { LnOrderHeader } from '../../entities/ln-order-header-entity';

@Component({
  selector: 'app-ln-order-header',
  templateUrl: './ln-order-header.component.html',
  styleUrls: ['./ln-order-header.component.scss'],
  standalone: false
})
export class LnOrderHeaderComponent implements OnInit {
  appStrings: AppLocalization;
  dateFormat: string;
  @Input() lnOrderHeaderResult: LnOrderHeader;

  constructor(
    private appInfoService: AppInfoService,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateFormat = this.appInfoService.dateFormat;
  }

}
